/** @format */
import { useHistory } from "react-router-dom";
import React, { Component } from "react";
import "react-notifications-component/dist/theme.css";
import "react-notifications/lib/notifications.css";
import "animate.css/animate.min.css";
import "animate.css/animate.compat.css";
import "animate.css";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { store } from "react-notifications-component";
import { XORCipher } from "./../global/XORCipher"
import {
	Container,
	Row,
	Col,
	Breadcrumb,
	BreadcrumbItem,
	Card,
	CardHeader,
	CardBody,
	CardText,
	Form,
	FormGroup,
	Label,
	Input,
	FormText,
	Button,
} from "reactstrap";
import Loader from "../components/Loader";
import jquery from "jquery";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
} from "../global/browserFunctions";
import { signup } from "../global/url";
import { showNotification } from "../global/notification";
import Select from "react-select";

class Signup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fname: "",
			lname: "",
			cname: "",
			country: { value: 1, label: "US" },
			phone: "",
			email: "",
			password: "",
			cpassword: "",
			loading: false,
			passwordHidden: true,
			cpasswordHidden: true,
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.toggleShow = this.toggleShow.bind(this);
		this.location = [
			{ value: 1, label: "US" },
			{ value: 2, label: "Canada" },
		];

		this.customSelectStyles = { //CSUTOM STYE FOR SELECT BOX
			control: (provided, state) => ({
				...provided,
				border: "1px solid #ced4da",
				borderRadius: "0",
				width: "100%",
				cursor: "pointer",
			}),
			indicatorSeparator: (provided, state) => ({
				display: "none",
			}),
			menu: (provided, state) => ({
				...provided,
				color: "#343a40",
				border: "0 solid #fff",
				borderRadius: 0,
				boxShadow: "0 0 1.2rem rgba(0, 0, 0, .15)",
			}),
			option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
				...provided,
				backgroundColor: isDisabled
					? null
					: isSelected
						? "#bcac76"
						: isFocused
							? "#eee"
							: null,
				":active": {
					...provided[":active"],
					backgroundColor: "#e2dabc",
				},
				cursor: "pointer",
			}),
		};
	}

	handleChange(e) {//Handles change from multiple input
		var target = e.target;
		var name = target.name;
		var value = target.value;
		this.setState({ [name]: value });
	}

	toggleShow(field) { //Hide/Show password field
		if (field == "password")
			this.setState({ passwordHidden: !this.state.passwordHidden });
		else this.setState({ cpasswordHidden: !this.state.cpasswordHidden });
	}

	GoToPage(path) {
		this.props.history.push(path);
	}

	isValidPhone(phone) {
		if (phone.length < 8) return "";
		else return "+" + phone;
	}

	handleSubmit(event) {
		event.preventDefault();
		var self = this;
		this.setState({ loading: true });
		var fname = this.state.fname;
		var lname = this.state.lname;
		var cname = this.state.cname;
		var phone = this.state.phone;
		var email = this.state.email;
		var country = this.state.country.value;
		var self = this;
		var password = this.state.password;
		// console.log('apassword',password)
		var cpassword = this.state.cpassword;
		// console.log('cpassword',cpassword)
		if (password !== cpassword) {
			// this.state.password = null;
			this.setState({ loading: false });
			showNotification("Password Not Match", "warning", " ");
			return false;
		}
		var tstamp = Date.parse(new Date()).toString()
		var encrypt = XORCipher.encode(tstamp, this.state.password)
		var query =
			"&firstName=" +
			encodeURIComponent(fname) +
			"&lastName=" +
			encodeURIComponent(lname) +
			"&company=" +
			encodeURIComponent(cname) +
			"&country=" +
			encodeURIComponent(country) +
			"&phone=" +
			encodeURIComponent(this.isValidPhone(phone)) +
			"&email=" +
			encodeURIComponent(email) +
			"&password=" +
			encodeURIComponent(encrypt) + "&timeStamp=" + encodeURIComponent(tstamp);

		console.log('query', query)
		this.setState({
			fname: "",
			lname: "",
			cname: "",
			country: { value: 1, label: "US" },
			phone: "",
			email: "",
			password: "",
			cpassword: "",
			loading: true,
			passwordHidden: true,
			cpasswordHidden: true,
		})
		jquery
			.ajax({
				url: signup + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				// console.log(data);
				data = JSON.parse(data);
				if (data.success) {
					self.setState({ loading: false });
					showNotification(
						"You have registered successfully!",
						"success",
						"We will be in contact with you soon"
					);
					setTimeout(
						function () {
							self.GoToPage("/thank-you");
						}.bind(this),
						2000
					);
					// setTimeout(
					// 	function () {
					// 		self.GoToPage("/home");
					// 	}.bind(this),
					// 	2000
					// );
					//	setCookie("log", true, 1);
					//	setCookie("name", self.state.cname || self.state.fname, 1);
				} else if (
					data.message == "There is already a customer with this emailaddress"
				) {
					self.setState({ loading: false });
					//   console.log("Email error");
					showNotification(
						"Info",
						"default",
						"Seems like you've already got an account with us"
					);
				} else if (data.error == "UNIQUE_CUST_ID_REQD") {
					//  console.log("Company error");
					self.setState({ loading: false });
					showNotification(
						"Info",
						"default",
						"This company is already in our system. Please login"
					);
				} else {
					//   console.log("Alredy Exist ");
					self.setState({ loading: false });
					showNotification(
						"Sorry",
						"danger",
						"An unknown error occurred. Please try again later"
					);
				}
			});
	}
	render() {
		return (
			<Col lg={{ size: 6, offset: 1 }}>
				<Loader loading={this.state.loading} />
				<Card>
					<CardHeader className='py-4 px-5'>
						<h5 className='mb-0'>New account</h5>
					</CardHeader>
					<CardBody className='p-5'>
						<Form onSubmit={this.handleSubmit}>
							<FormGroup>
								<Label className='form-label' for='firstname'>
									First Name
								</Label>
								<Input
									name='fname'
									type='text'
									pattern='^[a-zA-Z].*[\s\.]*$'
									required
									onChange={this.handleChange}
									value={this.state.fname}
								/>
							</FormGroup>
							<FormGroup>
								<Label className='form-label' for='lastname'>
									Last Name
								</Label>
								<Input
									name='lname'
									type='text'
									pattern='^[a-zA-Z].*[\s\.]*$'
									required
									onChange={this.handleChange}
									value={this.state.lname}
								/>
							</FormGroup>
							<FormGroup>
								<Label className='form-label' for='companyname'>
									Company Name
								</Label>
								<Input
									name='cname'
									type='text'
									required
									pattern='^[a-zA-Z].*[\s\.]*$'
									onChange={this.handleChange}
									value={this.state.cname}
								/>
							</FormGroup>
							<FormGroup>
								<Label className='form-label' for='country'>
									Country
								</Label>
								<Select
									name='country'
									options={this.location}
									defaultValue={this.location[0]}
									className='react-select-container'
									classNamePrefix='react-select'
									styles={this.customSelectStyles}
									onChange={(value) => this.setState({ country: value })}
									value={this.state.country}
								/>
							</FormGroup>
							<FormGroup>
								<Label className='form-label' for='phone'>
									Phone
								</Label>
								<ReactPhoneInput
									inputExtraProps={{
										name: "phone",
										required: true,
										autoFocus: true,
									}}
									country={"us"}
									value={this.state.phone}
									onChange={(phone) => this.setState({ phone })}
								/>
							</FormGroup>
							<FormGroup>
								<Label className='form-label' for='emailSignup'>
									Email
								</Label>
								<Input
									name='email'
									type='text'
									pattern='^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
									required
									onChange={this.handleChange}
									value={this.state.email}
								/>
							</FormGroup>
							<FormGroup>
								<Label className='form-label' for='password'>
									Password
								</Label>
								<Input
									name='password'
									type={this.state.passwordHidden ? "password" : "text"}
									pattern='.{8,}'
									required
									title='8 characters minimum'
									onChange={this.handleChange}
									value={this.state.password}
								/>
								<span
									className='fa fa-fw fa-eye field-icon-password'
									onClick={(event) => this.toggleShow("password")}
								></span>
							</FormGroup>
							<FormGroup>
								<Label className='form-label' for='cpassword'>
									Confirm Password
								</Label>
								<Input
									name='cpassword'
									type={this.state.cpasswordHidden ? "password" : "text"}
									pattern='.{8,}'
									required
									title='8 characters minimum'
									onChange={this.handleChange}
									value={this.state.cpassword}
								/>
								<span
									className='fa fa-fw fa-eye field-icon-password'
									onClick={this.toggleShow}
								></span>
							</FormGroup>
							<Button color='dark' type='submit'>
								<i className='far fa-user mr-2' /> Register
							</Button>
						</Form>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default Signup;
